var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiple-image-cta-section',{staticClass:"multiple-image-cta-section-module",attrs:{"items":_vm.formattedCtas}})}
var staticRenderFns = []

export { render, staticRenderFns }